// UI strings for Asetukset → Hylätyt muutokset: the changes the server refused that no other
// screen explains (settings/rejected.settings.tsx). Each line reuses review.rejected's texts.
import { defineArea } from '../area';

export const rejectedWritesFi = {
  title: 'Hylätyt muutokset',
  intro: 'Nämä muutokset eivät tallentuneet. Tee ne uudelleen, jos ne ovat yhä ajankohtaisia.',
  made: (date: string) => `Tehty ${date}`,
};

export const rejectedWritesEn: typeof rejectedWritesFi = {
  title: 'Refused changes',
  intro: 'These changes were not saved. Make them again if they still matter.',
  made: (date) => `Made ${date}`,
};

// Messages.rejectedWrites (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('rejectedWrites', rejectedWritesFi, rejectedWritesEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof rejectedWritesFi> {}
}
